/* BBEDDING theme.js — vanilla JS, no dependencies */
(function () {
  'use strict';

  document.documentElement.classList.remove('no-js');

  /* ---------------- Utilities ---------------- */
  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.from((ctx || document).querySelectorAll(sel)); }
  function fetchJSON(url, opts) {
    return fetch(url, opts).then(function (r) { return r.json(); });
  }
  function formatMoney(cents, format) {
    var value = (cents / 100).toFixed(2);
    return (format || '£{{amount}}').replace('{{amount}}', value);
  }

  /* ---------------- Mobile navigation ---------------- */
  var mobileToggle = qs('[data-mobile-nav-toggle]');
  var mobileNav = qs('[data-mobile-nav]');
  if (mobileToggle && mobileNav) {
    mobileToggle.addEventListener('click', function () {
      mobileNav.classList.add('is-open');
      mobileNav.setAttribute('aria-hidden', 'false');
    });
    qsa('[data-mobile-nav-close]', mobileNav).forEach(function (btn) {
      btn.addEventListener('click', function () {
        mobileNav.classList.remove('is-open');
        mobileNav.setAttribute('aria-hidden', 'true');
      });
    });
  }

  /* ---------------- Sticky header on scroll (transparent variant) ---------------- */
  var header = qs('.site-header.is-transparent');
  if (header) {
    var onScroll = function () {
      if (window.scrollY > 40) header.classList.add('is-scrolled');
      else header.classList.remove('is-scrolled');
    };
    document.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------------- Cart drawer ---------------- */
  var cartDrawer = qs('#CartDrawer');
  function openCartDrawer() {
    if (!cartDrawer) return;
    refreshCartDrawer().then(function () {
      cartDrawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    });
  }
  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  qsa('[data-cart-drawer-open]').forEach(function (el) {
    el.addEventListener('click', function (e) {
      if (window.themeSettings && window.themeSettings.cartType === 'page') return;
      e.preventDefault();
      openCartDrawer();
    });
  });
  qsa('[data-cart-drawer-close]').forEach(function (el) { el.addEventListener('click', closeCartDrawer); });

  function updateCartCountBubble(count) {
    qsa('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  function refreshCartDrawer() {
    return fetchJSON('/cart.js').then(function (cart) {
      updateCartCountBubble(cart.item_count);
      var body = qs('#CartDrawerBody');
      if (!body) return cart;
      if (cart.item_count === 0) {
        body.innerHTML = '<div class="empty-state"><p>Your basket is currently empty.</p><a class="btn btn--primary" href="/collections/all">Continue Shopping</a></div>';
        return cart;
      }
      var thresholdEl = document.body.getAttribute('data-free-shipping-threshold');
      var threshold = thresholdEl ? parseFloat(thresholdEl) * 100 : 0;
      var barHtml = '';
      if (threshold > 0) {
        var remaining = Math.max(threshold - cart.total_price, 0);
        var pct = Math.min((cart.total_price / threshold) * 100, 100);
        barHtml = '<div class="free-shipping-bar">' +
          (remaining > 0 ? 'You\'re ' + formatMoney(remaining) + ' away from free UK delivery.' : 'You\'ve unlocked free UK delivery.') +
          '<div class="free-shipping-bar__track"><div class="free-shipping-bar__fill" style="width:' + pct + '%"></div></div></div>';
      }
      var linesHtml = cart.items.map(function (item) {
        return '<div class="cart-line" data-line-key="' + item.key + '">' +
          '<img src="' + item.image + '&width=160" alt="' + item.title + '" width="80" height="80">' +
          '<div><p style="margin:0 0 4px;font-weight:600;">' + item.product_title + '</p>' +
          '<p style="margin:0 0 8px;font-size:.82rem;color:#777;">' + (item.variant_title || '') + '</p>' +
          '<div class="cart-line__qty"><button type="button" data-qty-decrease>-</button>' +
          '<input type="number" min="0" value="' + item.quantity + '" data-qty-input data-key="' + item.key + '">' +
          '<button type="button" data-qty-increase>+</button></div></div>' +
          '<div style="text-align:right"><p style="font-weight:700;">' + formatMoney(item.final_line_price) + '</p>' +
          '<button type="button" data-remove-line data-key="' + item.key + '" style="background:none;border:none;text-decoration:underline;font-size:.8rem;">Remove</button></div>' +
          '</div>';
      }).join('');
      body.innerHTML = barHtml + linesHtml +
        '<div class="cart-drawer__footer" style="margin-top:20px;">' +
        '<p style="display:flex;justify-content:space-between;font-weight:700;font-size:1.1rem;">Subtotal <span>' + formatMoney(cart.total_price) + '</span></p>' +
        '<p style="font-size:.8rem;color:#777;">Delivery, taxes and discounts calculated at checkout.</p>' +
        '<a href="/checkout" class="btn btn--primary btn--block" style="margin-top:12px;">Checkout</a>' +
        '<a href="/cart" class="btn btn--outline btn--block link-underline" style="margin-top:10px;">View Basket</a>' +
        '</div>';
      bindCartLineEvents(body);
      return cart;
    }).catch(function () { /* fail silently, native cart still works */ });
  }

  function bindCartLineEvents(scope) {
    qsa('[data-qty-increase]', scope).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var input = btn.parentElement.querySelector('[data-qty-input]');
        changeLineQty(input.dataset.key, parseInt(input.value, 10) + 1);
      });
    });
    qsa('[data-qty-decrease]', scope).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var input = btn.parentElement.querySelector('[data-qty-input]');
        changeLineQty(input.dataset.key, Math.max(parseInt(input.value, 10) - 1, 0));
      });
    });
    qsa('[data-qty-input]', scope).forEach(function (input) {
      input.addEventListener('change', function () { changeLineQty(input.dataset.key, parseInt(input.value, 10) || 0); });
    });
    qsa('[data-remove-line]', scope).forEach(function (btn) {
      btn.addEventListener('click', function () { changeLineQty(btn.dataset.key, 0); });
    });
  }

  function changeLineQty(key, quantity) {
    fetchJSON('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function () { refreshCartDrawer(); });
  }

  /* Intercept product-form add-to-cart submissions for AJAX add */
  qsa('form[data-product-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      if (form.dataset.buyNow) return; // let dynamic checkout buttons submit natively
      e.preventDefault();
      var submitBtn = form.querySelector('[type="submit"]');
      if (submitBtn) submitBtn.setAttribute('disabled', 'disabled');
      var formData = new FormData(form);
      fetch('/cart/add.js', { method: 'POST', body: formData, headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function () {
          if (submitBtn) submitBtn.removeAttribute('disabled');
          if (window.themeSettings && window.themeSettings.cartType === 'page') {
            window.location.href = '/cart';
          } else {
            openCartDrawer();
          }
        })
        .catch(function () {
          if (submitBtn) submitBtn.removeAttribute('disabled');
          form.submit();
        });
    });
  });

  /* ---------------- Search drawer ---------------- */
  var searchDrawer = qs('#SearchDrawer');
  qsa('[data-search-drawer-open]').forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      if (!searchDrawer) return;
      searchDrawer.setAttribute('aria-hidden', 'false');
      var input = qs('[data-predictive-search-input]', searchDrawer);
      if (input) setTimeout(function () { input.focus(); }, 100);
    });
  });
  qsa('[data-search-drawer-close]').forEach(function (el) {
    el.addEventListener('click', function () { searchDrawer.setAttribute('aria-hidden', 'true'); });
  });

  var searchInput = qs('[data-predictive-search-input]');
  var searchResults = qs('#PredictiveSearchResults');
  var searchTimer;
  if (searchInput && searchResults) {
    searchInput.addEventListener('input', function () {
      clearTimeout(searchTimer);
      var term = searchInput.value.trim();
      if (term.length < 2) { searchResults.innerHTML = ''; return; }
      searchTimer = setTimeout(function () {
        fetchJSON('/search/suggest.json?q=' + encodeURIComponent(term) + '&resources[type]=product,page,article&resources[limit]=6')
          .then(function (data) {
            var res = data.resources ? data.resources.results : null;
            if (!res || !res.products || res.products.length === 0) {
              searchResults.innerHTML = '<p style="padding:16px;color:#777;">No results found for "' + term + '"</p>';
              return;
            }
            searchResults.innerHTML = res.products.map(function (p) {
              return '<a href="' + p.url + '" style="display:flex;gap:14px;padding:12px 0;align-items:center;border-bottom:1px solid #eee;">' +
                (p.image ? '<img src="' + p.image + '" width="56" height="56" style="object-fit:cover;border-radius:8px;">' : '') +
                '<span><span style="display:block;font-weight:600;">' + p.title + '</span><span style="color:#777;">' + p.price + '</span></span></a>';
            }).join('');
          }).catch(function () {});
      }, 250);
    });
  }

  /* Close drawers with escape key */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeCartDrawer();
      if (searchDrawer) searchDrawer.setAttribute('aria-hidden', 'true');
      if (mobileNav) { mobileNav.classList.remove('is-open'); mobileNav.setAttribute('aria-hidden', 'true'); }
    }
  });

  /* ---------------- Accordions ---------------- */
  qsa('[data-accordion-trigger]').forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var expanded = trigger.getAttribute('aria-expanded') === 'true';
      var panel = document.getElementById(trigger.getAttribute('aria-controls'));
      trigger.setAttribute('aria-expanded', String(!expanded));
      if (panel) panel.style.maxHeight = expanded ? null : panel.scrollHeight + 'px';
    });
  });

  /* ---------------- Product gallery thumbnails ---------------- */
  qsa('[data-gallery]').forEach(function (gallery) {
    var mainImg = qs('[data-gallery-main] img', gallery);
    qsa('[data-gallery-thumb]', gallery).forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (mainImg) mainImg.src = thumb.dataset.fullSrc || thumb.src;
        qsa('[data-gallery-thumb]', gallery).forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  });

  /* ---------------- Variant selection ---------------- */
  qsa('[data-variant-selector]').forEach(function (root) {
    var variantsJSON = root.querySelector('[data-variant-json]');
    if (!variantsJSON) return;
    var variants = JSON.parse(variantsJSON.textContent);
    var priceEl = qs('[data-product-price]', root);
    var compareEl = qs('[data-product-compare-price]', root);
    var buyBtn = qs('[data-add-to-cart]', root);
    var idInput = qs('[data-variant-id-input]', root);
    var inventoryEl = qs('[data-inventory-status]', root);

    function findVariant() {
      var selected = qsa('[data-option-selected]', root).map(function (el) { return el.value; });
      return variants.find(function (v) { return v.options.every(function (o, i) { return o === selected[i]; }); });
    }
    function render() {
      var variant = findVariant();
      qsa('[data-variant-pill]', root).forEach(function (pill) {
        var testSelected = qsa('[data-option-selected]', root).map(function (el, i) {
          return el === pill.closest('[data-option-index="' + i + '"]') ? pill.dataset.value : el.value;
        });
      });
      if (!variant) return;
      if (idInput) idInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = formatMoney(variant.compare_at_price);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
      if (buyBtn) {
        buyBtn.disabled = !variant.available;
        buyBtn.textContent = variant.available ? buyBtn.dataset.labelAvailable : buyBtn.dataset.labelSoldOut;
      }
      if (inventoryEl) {
        if (!variant.available) {
          inventoryEl.className = 'inventory-status inventory-status--out';
          inventoryEl.textContent = 'Unavailable';
        } else if (variant.inventory_quantity !== undefined && variant.inventory_quantity > 0 && variant.inventory_quantity <= 5 && variant.inventory_management) {
          inventoryEl.className = 'inventory-status inventory-status--low';
          inventoryEl.textContent = 'Only ' + variant.inventory_quantity + ' left';
        } else {
          inventoryEl.className = 'inventory-status inventory-status--in';
          inventoryEl.textContent = 'In stock, ready to ship';
        }
      }
      if (variant.featured_image) {
        var mainImg = qs('[data-gallery-main] img');
        if (mainImg) mainImg.src = variant.featured_image.src;
      }
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      }
    }
    qsa('[data-option-selected]', root).forEach(function (el) { el.addEventListener('change', render); });
    qsa('[data-variant-pill]', root).forEach(function (pill) {
      pill.addEventListener('click', function () {
        if (pill.disabled) return;
        var group = pill.closest('[data-option-group]');
        qsa('[data-variant-pill]', group).forEach(function (p) { p.classList.remove('is-selected'); });
        pill.classList.add('is-selected');
        var hidden = qs('[data-option-selected]', group);
        if (hidden) hidden.value = pill.dataset.value;
        render();
      });
    });
    render();
  });

  /* ---------------- Quantity selector (product page) ---------------- */
  qsa('[data-quantity-selector]').forEach(function (sel) {
    var input = qs('input', sel);
    var minus = qs('[data-qty-minus]', sel);
    var plus = qs('[data-qty-plus]', sel);
    if (minus) minus.addEventListener('click', function () { input.value = Math.max(parseInt(input.value, 10) - 1, 1); });
    if (plus) plus.addEventListener('click', function () { input.value = parseInt(input.value, 10) + 1; });
  });

  /* ---------------- Sticky mobile add to cart ---------------- */
  var stickyBar = qs('[data-sticky-atc]');
  var mainForm = qs('[data-product-form]');
  if (stickyBar && mainForm) {
    var obs = new IntersectionObserver(function (entries) {
      stickyBar.classList.toggle('is-visible', !entries[0].isIntersecting);
    });
    obs.observe(mainForm);
  }

  /* ---------------- Newsletter (native Shopify form + friendly messaging) ---------------- */
  qsa('[data-newsletter-form]').forEach(function (form) {
    var msg = qs('[data-form-message]', form);
    if (!msg) return;
    if (window.location.search.indexOf('customer_posted=true') > -1 && form.contains(document.activeElement)) {
      msg.textContent = 'Thanks — you\'re on the list!';
      msg.className = 'form-message form-message--success';
    }
  });

  /* ---------------- Before & After slider ---------------- */
  qsa('[data-before-after]').forEach(function (root) {
    var frame = qs('.before-after__frame', root);
    var input = qs('[data-before-after-input]', root);
    var handle = qs('[data-before-after-handle]', root);
    var clipEl = qs('[data-before-after-clip]', root);
    if (!frame || !input || !handle || !clipEl) return;

    function setPosition(pct) {
      pct = Math.max(0, Math.min(100, pct));
      clipEl.style.clipPath = 'inset(0 ' + (100 - pct) + '% 0 0)';
      handle.style.left = pct + '%';
      input.value = pct;
    }

    input.addEventListener('input', function () { setPosition(parseFloat(input.value)); });

    function pointerToPercent(clientX) {
      var rect = frame.getBoundingClientRect();
      return ((clientX - rect.left) / rect.width) * 100;
    }
    var dragging = false;
    frame.addEventListener('pointerdown', function (e) { dragging = true; setPosition(pointerToPercent(e.clientX)); });
    window.addEventListener('pointermove', function (e) { if (dragging) setPosition(pointerToPercent(e.clientX)); });
    window.addEventListener('pointerup', function () { dragging = false; });
  });

  /* ---------------- Announcement bar rotation ---------------- */
  var track = qs('[data-announcement-track]');
  if (track) {
    var items = qsa('.announcement-bar__item', track);
    var interval = parseInt(track.dataset.interval || '5000', 10);
    var i = 0;
    if (items.length > 1) {
      items.forEach(function (item, idx) { item.style.display = idx === 0 ? '' : 'none'; });
      var timer = setInterval(function () {
        items[i].style.display = 'none';
        i = (i + 1) % items.length;
        items[i].style.display = '';
      }, interval);
      track.addEventListener('mouseenter', function () { clearInterval(timer); });
    }
  }

  /* ---------------- Colour swatch -> product-card image swap ---------------- */
  qsa('[data-card-swatch]').forEach(function (swatch) {
    swatch.addEventListener('click', function (e) {
      e.preventDefault();
      var card = swatch.closest('.product-card');
      var img = qs('.product-card__img--front', card);
      if (img && swatch.dataset.image) img.src = swatch.dataset.image;
    });
  });

})();
